// Splits AI-generated post/blog body text into paragraph and heading blocks:
// - markdown-style "### Heading" lines become real sub-headings instead of
//   showing the literal "###" characters
// - blank lines mark paragraph breaks that get a single CSS margin, rather
//   than being preserved literally by white-space: pre-wrap (which doubled
//   the visual gap between paragraphs)
export const formatBlogBody = (text) => {
  if (!text) return [];

  const blocks = [];
  const sections = text.split(/\n{2,}/);
  let key = 0;

  sections.forEach((section) => {
    let paragraphLines = [];

    const flushParagraph = () => {
      const paragraph = paragraphLines.join('\n').trim();
      if (paragraph) {
        blocks.push({ type: 'paragraph', key: `p-${key}`, text: paragraph });
        key += 1;
      }
      paragraphLines = [];
    };

    section.split('\n').forEach((line) => {
      const headingMatch = line.match(/^#{1,6}\s+(.+?)\s*#*\s*$/);
      if (headingMatch) {
        flushParagraph();
        blocks.push({ type: 'heading', key: `h-${key}`, text: headingMatch[1] });
        key += 1;
      } else {
        paragraphLines.push(line);
      }
    });
    flushParagraph();
  });

  return blocks;
};
